import { Button } from "./ui/button";
import { Heart, User, Search, Users, Sparkles, Star, Gift } from "lucide-react";
import loveReportBook from "../../../assets/images/love-report/2.webp";

const HowItWorksSection = () => {

  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const steps = [
    {
      number: 1,
      icon: User,
      title: "Provide Us with Your Birth Details",
      description: "All we need are your birth date, time, and place to create an accurate chart and prepare your Love Report."
    },
    {
      number: 2,
      icon: Search,
      title: "In-depth Astrological Analysis",
      description: "Acharya LavBhushan analyzes your chart—zodiac, planets, and more—to reveal your love personality, emotions, and unique romantic traits."
    },
    {
      number: 3,
      icon: Users,
      title: "Compatibility Insights",
      description: "Your chart reveals love compatibility with your partner, offering insights into relationship patterns and ways to improve them."
    },
    {
      number: 4,
      icon: Sparkles,
      title: "Love Predictions",
      description: "We provide a soulmate compatibility report based on planetary transits, highlighting future love prospects and guiding wiser relationship decisions."
    },
    {
      number: 5,
      icon: Star,
      title: "Practical Remedies & Solutions",
      description: "Your Love Report includes remedies like gemstones, mantras, and conflict-solving tips to strengthen your relationships."
    },
    {
      number: 6,
      icon: Gift,
      title: "Get Your Personalized Love Report",
      description: "After analysis, you receive a clear, personalized Love Report with practical tips for a better love life and healthier relationships."
    }
  ];

  return (
    <section className="py-12 lg:py-20 bg-background_lv">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 lg:mb-6">
            How Our <span className="text-love-pink">Love Report</span> Works
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-start">
          {/* Left side - Book Image */}
          <div className="flex justify-center order-last lg:order-first">
            <div className="relative">

              <img
                src={loveReportBook}
                alt="Love Report Book"
                className="relative h-64 sm:h-80 lg:h-96 w-auto object-contain drop-shadow-2xl mx-auto"
              />
              <div className="mt-4 lg:mt-8 text-center">
                <Button onClick={handleScrollToPricing} variant="love" size="lg" className="text-sm lg:text-lg px-6 lg:px-8 py-3 lg:py-4 w-full sm:w-auto">
                  Get Your Report Now
                </Button>
              </div>
            </div>
          </div>

          {/* Right side - Steps */}
          <div className="space-y-6 lg:space-y-8 order-first lg:order-last">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start space-x-3 lg:space-x-4">
                {/* Step Number & Icon */}
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 bg-love-pink rounded-full flex items-center justify-center text-love-pink-foreground font-bold">
                    <Heart className="h-4 w-4 lg:h-6 lg:w-6" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-lg lg:text-xl font-bold mb-1 lg:mb-2 text-love-pink">
                    Step {step.number}: {step.title}
                  </h3>
                  <p className="text-muted_lv-foreground leading-relaxed text-sm lg:text-base">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;